import { InformationCircleIcon } from '@heroicons/react/24/solid'
import Tippy from '@tippyjs/react'
import Image from 'next/image'
import { FC } from 'react'

import { RequestStatus } from '@/api/models/requests/lib/requests.types'
import { cn } from '@/app/utils'

type Props = {
  status?: RequestStatus
  className?: string
  isDescriptionVisible?: boolean
  statusNameTestId?: string
}

const RequestStatusBadge: FC<Props> = ({
  status,
  className,
  isDescriptionVisible,
  statusNameTestId = 'request-status-name-id'
}) => {
  if (!status?.isActive) {
    return null
  }

  return (
    <div className="flex items-center gap-8">
      <div
        data-testid="request-status-badge-id"
        style={{ backgroundColor: status?.color }}
        className={cn(
          className,
          'relative flex w-fit items-center gap-4 rounded-16 py-2 pl-[8px] pr-[4px] text-white'
        )}
      >
        {status?.iconUrl && (
          <Image
            src={status.iconUrl}
            alt={status.name}
            width={16}
            height={16}
          />
        )}
        <span
          data-testid={statusNameTestId}
          className="relative -top-1 pr-5 font-bold text-16"
        >
          {status?.name.toLowerCase()}
        </span>
      </div>
      {status.description && isDescriptionVisible && (
        <Tippy
          content={
            <div
              data-testid="request-status-tooltip-content-id"
              className="rounded-12 bg-white p-12 shadow-[0px_5px_30px_0px_rgba(0,0,0,0.15)] "
            >
              <p className="text-grey-100 text-16">{status.description}</p>
            </div>
          }
          trigger="click mouseenter"
          hideOnClick={true}
          placement="bottom-start"
          arrow={false}
          className="flex w-[280px]"
        >
          <InformationCircleIcon
            data-testid="request-status-tooltip-trigger-id"
            className="h-24 w-24 cursor-pointer  text-grey-40"
          />
        </Tippy>
      )}
    </div>
  )
}

export default RequestStatusBadge
